"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const clone_1 = tslib_1.__importDefault(require("lodash/clone"));
const getContent_1 = require("../helpers/getContent");
const getContentType_1 = require("../helpers/getContentType");
const getProgressMeasureUpdatedEvent_1 = require("../helpers/getEvent/getProgressMeasureUpdatedEvent");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
function updateProgressMeasureOfState(command, state) {
    const { sessionState } = command;
    if (sessionState.attended) {
        state.progressMeasure = 1;
        state.scaledProgressMeasure = 1;
        return;
    }
    state.progressMeasure = 0;
    state.scaledProgressMeasure = 0;
    return;
}
function updateIltSessionStateWithSessionState(command, user, content, states) {
    const { sessionId, timeStamp, sessionState } = command;
    const sessionStateCloned = clone_1.default(sessionState);
    const { userId, companyId } = user;
    const events = [];
    const state = getState_1.getStateByContentIdUserId(states, sessionId, userId);
    const currentProgressMeasure = state.progressMeasure;
    if (sessionStateCloned.sessionId) {
        delete sessionStateCloned.sessionId;
    }
    updateProgressMeasureOfState(command, state);
    let { meta = '{}' } = state;
    if (meta) {
        meta = JSON.parse(meta);
    }
    meta = Object.assign({}, meta, sessionStateCloned);
    state.meta = JSON.stringify(meta);
    state.updatedAt = timeStamp;
    const contentType = entity_1.ContentType.ILT_SESSION;
    if (currentProgressMeasure !== state.progressMeasure) {
        // const progressMeasureUpdatedEvent = getProgressMeasureUpdatedEvent(
        getProgressMeasureUpdatedEvent_1.getProgressMeasureUpdatedEvent(command, companyId, userId, content._id, contentType, currentProgressMeasure, state.progressMeasure);
        // events.push(progressMeasureUpdatedEvent);
    }
    return events;
}
function applyUpdateIltSessionStateCommand(command, user, content, states) {
    const { contentId, sessionId, timeStamp, sessionState } = command;
    const { userId, companyId } = user;
    const events = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        const sessionStateUpdateEvents = updateIltSessionStateWithSessionState(command, user, content, draftStates);
        const state = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        let { meta = JSON.stringify({}) } = state;
        if (meta) {
            meta = JSON.parse(meta);
        }
        const currentProgressMeasure = state.progressMeasure;
        if (!meta.sessionStates) {
            meta.sessionStates = [];
        }
        const currentSessionStateIndex = meta.sessionStates.findIndex((s) => s.sessionId === sessionId);
        if (currentSessionStateIndex < 0) {
            meta.sessionStates.push(sessionState);
        }
        else {
            const currentSessionState = meta.sessionStates[currentSessionStateIndex];
            meta.sessionStates[currentSessionStateIndex] = Object.assign({}, currentSessionState, sessionState);
        }
        state.meta = JSON.stringify(meta);
        updateProgressMeasureOfState(command, state);
        state.updatedAt = timeStamp;
        const currentContent = getContent_1.getContentByContentId(content, contentId);
        const contentType = getContentType_1.getContentType(currentContent);
        if (currentProgressMeasure !== state.progressMeasure) {
            const progressMeasureUpdatedEvent = getProgressMeasureUpdatedEvent_1.getProgressMeasureUpdatedEvent(command, companyId, userId, content._id, contentType, currentProgressMeasure, state.progressMeasure);
            events.push(progressMeasureUpdatedEvent, ...sessionStateUpdateEvents);
        }
    });
    return { states: updatedStates, events, stateInteractions: [], enrolments: [] };
}
exports.applyUpdateIltSessionStateCommand = applyUpdateIltSessionStateCommand;
//# sourceMappingURL=applyUpdateIltSessionStateCommand.js.map